// extracted by mini-css-extract-plugin
export default {"list":"OrganizationSortedArtistsList_list__Zm7s4"};